export default {"src":"/_next/static/media/github.2e9b5852.svg","height":52,"width":94,"blurWidth":0,"blurHeight":0};